import useReactRouter from 'use-react-router'

export const useParams = <TParams extends { [key: string]: string | undefined }>(): TParams => {
  const { match } = useReactRouter<TParams>()

  return match.params
}
